export default "__VITE_ASSET__D6NDwf1u__"